import React from 'react';
import { Card } from 'react-bootstrap';

const InfoWindow = ({ data, close, darkMode }) => {
  if (!data) return null;

  return (
    <Card
      className="info-window"
      style={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        width: '300px',
        background: darkMode ? 'rgba(33, 37, 41, 0.95)' : 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        border: darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)',
        zIndex: 1000
      }}
    >
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h6 className="mb-0" style={{ color: darkMode ? '#fff' : '#000' }}>
          {data.properties.data.state} ({data.properties.data.stateAbbrev})
        </h6>
        <button
          onClick={close}
          className="btn-close"
          style={{ filter: darkMode ? 'invert(1)' : 'none' }}
        />
      </Card.Header>
      
      <Card.Body>
        <div style={{ color: darkMode ? '#fff' : '#000' }}>
          <p><strong>Grão:</strong> {data.properties.data.grain}</p>
          <p><strong>Umidade Média:</strong> {data.properties.data.humidity.toFixed(2)}%</p>
          <p><strong>Peso Médio:</strong> {data.properties.data.weight.toFixed(2)}g</p>
          <p><strong>PH Médio:</strong> {data.properties.data.ph.toFixed(2)}</p>
          <p><strong>Temperatura Média:</strong> {data.properties.data.temperature.toFixed(2)}°C</p>
          <p><strong>Quantidade de Medições:</strong> {data.properties.data.quantity}</p>
          <p><strong>Período:</strong> {new Date(0, data.properties.data.month - 1).toLocaleString('pt-BR', { month: 'long' })} / {data.properties.data.year}</p>
        </div>
      </Card.Body>
    </Card>
  );
};

export default InfoWindow;
